module.exports = __webpack_public_path__ + "de77a722/img/document.e2130c6b.svg";